export type WalletToYouzanProps = {
  id: string;
  walletId?: number | string;
};

export const defaults = {
  id: undefined,
  walletId: 108,
};
